import {
    GET_CURRENT_USER_ROLES_FAILURE,
    GET_CURRENT_USER_ROLES_REQUEST,
    GET_CURRENT_USER_ROLES_SUCCESS
} from "../actions/actionTypes";
import { getHighestRole, userHasRole } from "../lib/userRolesHelper";
import UserRole from "../lib/roles";

const initState = {
    isFetching: false,
    isAdmin: false,
    isAccountAdmin: false,
    isSalesAppOnly: false,
    hasMax: false,
    hasHideSummaryReports: false,
    hasNearmapDisabled: false,
    isSketchTech: false,
    isSketchOsAdmin: false,
    hasSketchOsEnabled: false,
    position: null,
    hasExpSketchToolEnabled: false,
};

const currentUserRolesReducer = (state = initState, action) => {
    switch (action.type) {
        case GET_CURRENT_USER_ROLES_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
            });
        case GET_CURRENT_USER_ROLES_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                isAdmin: userHasRole(action.response, UserRole.Admin),
                isAccountAdmin: userHasRole(action.response, UserRole.AccountAdmin),
                isSalesAppOnly: userHasRole(action.response, UserRole.SalesAppOnly),
                hasHideSummaryReports: userHasRole(action.response, UserRole.HideSummaryReports),
                hasNearmapDisabled: userHasRole(action.response, UserRole.NearmapDisabled),
                hasMax: userHasRole(action.response, UserRole.Max),
                isSketchTech: userHasRole(action.response, UserRole.SketchTech),
                isSketchOsAdmin: userHasRole(action.response, UserRole.SketchOsAdmin),
                hasSketchOsEnabled: userHasRole(action.response, UserRole.SketchOsEnabled) ||
                    userHasRole(action.response, UserRole.SketchTech) ||
                    userHasRole(action.response, UserRole.SketchOsAdmin) ||
                    userHasRole(action.response, UserRole.Admin),
                position: getHighestRole(action.response),
                hasExpSketchToolEnabled: userHasRole(action.response, UserRole.SketchOsExpSketchToolEnabled),
            });
        case GET_CURRENT_USER_ROLES_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
            });
        default:
            return state;
    }
};

export default currentUserRolesReducer;
